module.exports = __webpack_public_path__ + "img/widget.72d8bb04.jpg";